import { Component, OnInit } from '@angular/core';
import { ArticleService } from '../../../services/article.service';
import { CArticle } from '../../../models/article.models/article.model';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { CArticleSearchModel } from '../../../models/article.models/articleSearchModel.model';

import { switchMap } from 'rxjs/operators';
import { CommonPageService } from '../../../services/commonPage.service';
import { Title, Meta } from '@angular/platform-browser';
import { CCommonPage } from '../../../models/page.models/commonPage.model';
import { themservice } from 'src/app/services/them.service';
// import { themservice } from 'src/app/services/them.service';
// import { themservice } from '../../../services/them.service';

@Component({
    selector: 'articles',
    templateUrl: 'articles.component.html'
})
export class ArticlesComponent implements OnInit {

    ngOnInit(): void {
        
        this.GetCommonPage();

        this.route.paramMap.pipe(
            switchMap((params: ParamMap) => {
                this.currentPage = Number(params.get('id'));

                return this.GetArticleArray();
            })).subscribe((data: CArticle[]) =>{ 
                this.articleArray = data;
                console.log(data)
            });

        this.GetPageCount();
    }

    countPerPage: number;
    articleArray: CArticle[] = [];
    ApiServiceAddress: string;
    currentPage: number;
    pager: number[] = [];
    commonPage: CCommonPage = new CCommonPage();
    id: string = 'ArticlesIndex';

    constructor(private articleService: ArticleService, private route: ActivatedRoute, private router: Router,public themservice:themservice,
        private commonPageService: CommonPageService, private titleService: Title, private metaService: Meta) {
        this.countPerPage = 9;
        this.ApiServiceAddress = API_ServerAddress;
    }


    GetArticleArray() {
        let searchModel: CArticleSearchModel = new CArticleSearchModel();
        searchModel.OrderByDESC = 'fId';
        searchModel.Fetch = this.countPerPage;
        searchModel.Offset = (this.currentPage - 1) * this.countPerPage;
        return this.articleService.GetList(searchModel);
    }

    GetPageCount() {
        this.articleService.Count(null).subscribe((data: number) => {
            var pcount = data / this.countPerPage;
            if (data % this.countPerPage > 0) {
                pcount++;
            }
            for (let i = 1; i <= pcount; i++) {
                this.pager.push(i);
            }
        })
    }

    GetCommonPage() {
        this.commonPageService.GetById(this.id)
            .subscribe((data: CCommonPage) => {
                this.commonPage = data;
                this.SetPageMetaData(data);
            });
    }

    SetPageMetaData(model: CCommonPage) {
        this.titleService.setTitle(model.fMetaTitle);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }

    MakeShortDescription(input : string){
        return input.substring(0, 250) + " . . . ";
    }
}